<script>
import { objectToCssVariablesDeprecated } from '@zyro-inc/site-modules/utils/objectToCssVariablesDeprecated';

export default {
	props: {
		text: {
			type: String,
			default: '',
		},
		ribbonStyle: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {
		computedStyles() {
			return {
				...objectToCssVariablesDeprecated(this.ribbonStyle),
			};
		},
	},
};
</script>

<template>
	<div
		class="ecommerce-product-ribbon"
		:style="computedStyles"
	>
		<p class="ecommerce-product-ribbon__text">
			{{ text }}
		</p>
	</div>
</template>

<style lang="scss">
@import "@zyro-inc/site-modules/scss/mixins/font-style";
@include font-style("body-small", ".ecommerce-product-ribbon");

$margin: 8px;

.ecommerce-product-ribbon {
	position: absolute;
	z-index: 1;
	display: flex;
	max-height: calc(100% - ($margin * 2));
	padding: 6px 12px;
	margin: $margin $margin $margin 0;
	text-align: left;
	background-color: var(--ribbon-background-color, $color-dark);

	&__text {
		overflow: hidden;
		color: var(--ribbon-color, $color-light) !important;
		word-break: break-word;
	}
}
</style>
